import { createSlice } from '@reduxjs/toolkit';

// Possible auth modules
export const authModules = {
    LOGIN: 'login',
    REGISTER: 'register',
    GUEST: 'guest'
};

// Possible auth modules forms
export const authModulesForms = {
    LOGIN_FORM: 'loginForm',
    FORGOT_PASSWORD_FORM: 'forgotPasswordForm',
    VERIFY_EMAIL_FORM: 'verifyEmailForm',
    COMPLETE_PROFILE_FORM: 'completeProfileForm',
    GUEST_LOGIN_FORM: 'guestLoginForm',
    INVALID_LINK: 'invalidLink'
};

const initialState = {
    isAuthDialogOpen: false,
    activeAuthModule: authModules.LOGIN,
    activeAuthModuleForm: authModulesForms.LOGIN_FORM,
    showGuestLoginForm: true
};

const authDialogSlice = createSlice({
    name: 'authDialog',
    initialState,
    reducers: {
        openAuthDialog: (state) => {
            state.isAuthDialogOpen = true;
        },
        closeAuthDialog: (state) => {
            state.isAuthDialogOpen = false;
        },
        setActiveAuthModule: (state, action) => {
            state.activeAuthModule = action.payload;
        },
        setActiveAuthModuleForm: (state, action) => {
            state.activeAuthModuleForm = action.payload;
        },
        attachedGuestLoginForm: (state, action) => {
            state.showGuestLoginForm = action.payload;
        }
    }
});

export const {
    openAuthDialog,
    closeAuthDialog,
    setActiveAuthModule,
    setActiveAuthModuleForm,
    attachedGuestLoginForm
} = authDialogSlice.actions;

export default authDialogSlice.reducer;
